import { FloatingInspectorButtonIcon } from '../FloatingInspectorButtons'
import LogoCreatePage from '@assets/images/logo-create-page.svg'
import { NavbarButtonBaseProps } from '../../Navbar/navbarConfig'

function LogoIconAndTextBtn({ disabled }: NavbarButtonBaseProps) {
  return (
    <FloatingInspectorButtonIcon
      onClick={() => {}}
      disabled={disabled}
      style={{ height: '40px', padding: '6px', gap: '8px', borderRadius: '12px' }}
      icon={
        <img
          src={LogoCreatePage}
          style={{
            height: '28px',
            width: 'auto',
            opacity: disabled ? 0.5 : 1,
          }}
        />
      }
    />
  )
}

export default LogoIconAndTextBtn
